import React, { Component } from 'react'
import SpecialKeysReact from 'special-keys-react'
import { t, getCurrentLanguage } from 'translation'

import PlayerWelcomeVideo from 'components/VideoPlayer/VideoPlayer'
import LottieImage from 'components/Lottie/LottieImage'

import history from 'utils/appHistory'
import { getWelcomeUrl } from 'utils/http'

import Checkmark from '../assets/checkbox.svg'
import { connect } from 'react-redux'

const welcomeVideo = {
  en: {
    mobile: 'anim_en.mp4',
    browser: 'anim_tb_en.mp4',
  },
  fr: {
    mobile: 'anim_fr.mp4',
    browser: 'anim_tb_fr.mp4',
  },
}

class WelcomePage extends Component {
  constructor() {
    super()
    document.documentElement.classList.remove('no_scale_mod')

    SpecialKeysReact.config({
      left: () => {
        if (this.state.welcomeVideoUrl === null) {
          this.btnWatchVideo.current.focus()
          return
        }

        this.closeImmersiveButton.click()
      },
      right: () => {
        if (this.state.welcomeVideoUrl !== null) return

        this.btnSkipVideo.current.focus()
      },
      up: () => {},
      down: () => {},
      backspace: () => {},
      enter: () => {},
    })

    this.mainElement = React.createRef()
    this.btnWatchVideo = React.createRef()
    this.btnSkipVideo = React.createRef()
  }
  state = { welcomeVideoUrl: null }

  welcomeVideoElement = null
  closeImmersiveButton = null

  attachCloseImmersiveBtnRef = (btn) => (this.closeImmersiveButton = btn)

  attachWelcomeVideoRef = (videoEl) => {
    if (videoEl) videoEl.addEventListener('ended', (e) => this.closeVideoHandler(e, true))
    this.welcomeVideoElement = videoEl
  }

  watchVideoHandler = () => {
    const screen = window.innerWidth >= 768 ? 'browser' : 'mobile'
    const fileName = welcomeVideo[getCurrentLanguage()][screen]
    const welcomeVideoUrl = getWelcomeUrl(fileName)

    this.setState({ welcomeVideoUrl }, () => this.welcomeVideoElement.play())
  }

  closeVideoHandler = (e, redirect) => {
    if (e) e.stopPropagation()
    if (this.welcomeVideoElement) {
      if (!this.welcomeVideoElement.paused) this.welcomeVideoElement.pause()

      this.welcomeVideoElement.removeEventListener('ended', (e) =>
        this.closeVideoHandler(e, true)
      )
    }
    if (redirect)
      this.setState({ welcomeVideoUrl: null }, () => history.push('/indication-select'))
    else {
      this.setState({ welcomeVideoUrl: null })
    }
  }

  skipVideoHandler = () => history.push('/indication-select')

  componentDidMount() {
    this.mainElement.current.focus()
  }

  componentDidUpdate() {
    this.mainElement.current.focus()
  }

  render() {
    return (
      <section
        className="section scroll_mod offset_v2_mod welcome_mod"
        ref={this.mainElement}
        {...SpecialKeysReact.events}
        tabIndex="1"
      >
        <div className="section_in">
          <div className="section_heading welcome_mod">
            <h2 className="section_title center_level_mod offset_v1_mod">
              {t('welcome.HOW_TO_USE')}
            </h2>
          </div>
          <div className="welcome_block">
            {/* <div className="welcome_img">
              <LottieImage />
              <img src={WelcomeImage} alt={t('welcome.WELCOME')} />
            </div> */}
            <ul className="welcome_list">
              <li className="welcome_entry">
                <div className="welcome_checkmark">
                  <Checkmark className="icon size_mod" />
                </div>
                <div className="welcome_text">{t('welcome.CHOOSE_ENVIRONMENT')}</div>
              </li>
              <li className="welcome_entry">
                <div className="welcome_checkmark">
                  <Checkmark className="icon size_mod" />
                </div>
                <div className="welcome_text">{t('welcome.USE_EARPHONES')}</div>
              </li>
              <li className="welcome_entry">
                <div className="welcome_checkmark">
                  <Checkmark className="icon size_mod" />
                </div>
                <div className="welcome_text">{t('welcome.LIE_DOWN')}</div>
              </li>
            </ul>
          </div>
          <div className="welcome_btn_container">
            <div className="welcome_btn_wrap">
              <button
                ref={this.btnWatchVideo}
                disabled={!this.props.isOnline}
                className="btn_add welcome_mod"
                onClick={this.watchVideoHandler}
              >
                {t('welcome.WATCH_VIDEO')}
              </button>
              <button
                ref={this.btnSkipVideo}
                className="btn_add welcome_mod"
                onClick={this.skipVideoHandler}
              >
                {t('welcome.SKIP_VIDEO')}
              </button>
            </div>
          </div>
        </div>
        {/* reuse player classes */}
        {this.state.welcomeVideoUrl && (
          <PlayerWelcomeVideo
            closeImmersiveVideoHandler={(e) => this.closeVideoHandler(e)}
            attachCloseImmersiveBtnRef={this.attachCloseImmersiveBtnRef}
            setVideoRef={this.attachWelcomeVideoRef}
            videoUrl={this.state.welcomeVideoUrl}
            loop={false}
            muted={false}
          />
        )}
      </section>
    )
  }
}

const mapStateToProps = ({ auth: { isOnline } }) => ({
  isOnline,
})

export default connect(mapStateToProps)(WelcomePage)
